var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCpu = function SvgIconCpu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.375 8.375a1 1 0 0 0-1 1v5.25a1 1 0 0 0 1 1h5.25a1 1 0 0 0 1-1v-5.25a1 1 0 0 0-1-1zm1 5.25v-3.25h3.25v3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1.25a1 1 0 0 1 1 1V3.5h3.5c.966 0 1.75.784 1.75 1.75v3.5h1.25a1 1 0 1 1 0 2H20.5v2.5h1.25a1 1 0 1 1 0 2H20.5v3.5a1.75 1.75 0 0 1-1.75 1.75h-3.5v1.25a1 1 0 1 1-2 0V20.5h-2.5v1.25a1 1 0 1 1-2 0V20.5h-3.5a1.75 1.75 0 0 1-1.75-1.75v-3.5H2.25a1 1 0 1 1 0-2H3.5v-2.5H2.25a1 1 0 1 1 0-2H3.5v-3.5c0-.966.784-1.75 1.75-1.75h3.5V2.25a1 1 0 0 1 2 0V3.5h2.5V2.25a1 1 0 0 1 1-1M5.5 5.5v13h13v-13z"
  }))));
};
export default SvgIconCpu;